"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentTypeFromExtension = exports.getRunnitNodeRunResultDownloadFilePath = exports.buildFileNameForAvatarDownload = exports.buildFileNameForRunnitUploadDownload = exports.buildFileNameForRunnitNodeRunResultDownload = exports.getRunnitLayerDownloadFilePath = exports.getRunnitModelFilePath = exports.getRunnitMaskFilePath = exports.getAvatarFilePath = exports.getRunnitUploadFilePath = exports.getRunnitNodeRunResultFilePath = exports.AVATAR_SIZE = exports.THUMB_SIZE = void 0;
const types_1 = require("./types");
const lodash_1 = require("lodash");
const utils_1 = require("./utils");
const runnitNodes_1 = require("./runnitNodes");
exports.THUMB_SIZE = 512;
exports.AVATAR_SIZE = 256;
const getRunnitNodeRunResultFilePath = (nodeRunResult) => {
    // For template nodeRuns, use templateOriginalData.nodeRunId to find files in the original location
    // Otherwise, use the nodeRunResult.nodeRunId
    const nodeRunIdToUse = (0, lodash_1.get)(nodeRunResult, 'templateOriginalData.nodeRunId') || nodeRunResult.nodeRunId;
    const teamIdToUse = (0, lodash_1.get)(nodeRunResult, 'templateOriginalData.teamId') || nodeRunResult.teamId;
    const userIdToUse = (0, lodash_1.get)(nodeRunResult, 'templateOriginalData.userId') || nodeRunResult.userId;
    const filePathPrefix = teamIdToUse
        ? `runnitResults/teams/${teamIdToUse}/runs/${nodeRunIdToUse}/`
        : `runnitResults/users/${userIdToUse}/runs/${nodeRunIdToUse}/`;
    // For LAYERS type, use displayFile for thumbnails and display
    if (nodeRunResult.type === 'LAYERS' && nodeRunResult.displayFile) {
        // Coerce a missing/null name to '' — a provider may omit file_name, and
        // `null.replace()` would otherwise throw an uncaught TypeError here.
        const fileName = nodeRunResult.displayFile.name || '';
        const filePath = `${filePathPrefix}${fileName}`;
        const thumbFileEnding = `thumbs/${fileName.replace(/\.[^/.]+$/, `_${exports.THUMB_SIZE}x${exports.THUMB_SIZE}.webp`)}`;
        const thumbFilePath = `${filePathPrefix}${thumbFileEnding}`;
        const gifFileEnding = `thumbs/${fileName.replace(/\.[^/.]+$/, `_${exports.THUMB_SIZE}x${exports.THUMB_SIZE}.gif`)}`;
        const gifFilePath = `${filePathPrefix}${gifFileEnding}`;
        const mp4FileEnding = `thumbs/${fileName.replace(/\.[^/.]+$/, `_${exports.THUMB_SIZE}x${exports.THUMB_SIZE}.mp4`)}`;
        const mp4FilePath = `${filePathPrefix}${mp4FileEnding}`;
        return { filePath, thumbFilePath, gifFilePath, mp4FilePath };
    }
    // For other types, use the standard file property.
    // NOTE: lodash `get` only substitutes the default for `undefined`, NOT `null`.
    // Some results carry an explicit `file.name: null` (e.g. a provider returned no
    // file_name and the bytes were never persisted), so `|| ''` is required to avoid
    // `null.replace()` throwing an uncaught TypeError.
    const fileName = (0, lodash_1.get)(nodeRunResult, 'file.name') || '';
    const filePath = `${filePathPrefix}${fileName}`;
    const thumbFileEnding = `thumbs/${fileName.replace(/\.[^/.]+$/, `_${exports.THUMB_SIZE}x${exports.THUMB_SIZE}.webp`)}`;
    const thumbFilePath = `${filePathPrefix}${thumbFileEnding}`;
    const gifFileEnding = `thumbs/${fileName.replace(/\.[^/.]+$/, `_${exports.THUMB_SIZE}x${exports.THUMB_SIZE}.gif`)}`;
    const gifFilePath = `${filePathPrefix}${gifFileEnding}`;
    const mp4FileEnding = `thumbs/${fileName.replace(/\.[^/.]+$/, `_${exports.THUMB_SIZE}x${exports.THUMB_SIZE}.mp4`)}`;
    const mp4FilePath = `${filePathPrefix}${mp4FileEnding}`;
    return { filePath, thumbFilePath, gifFilePath, mp4FilePath };
};
exports.getRunnitNodeRunResultFilePath = getRunnitNodeRunResultFilePath;
const getRunnitUploadFilePath = (upload) => {
    const filePathPrefix = upload.teamId
        ? `runnitUploads/teams/${upload.teamId}/uploads/`
        : `runnitUploads/users/${upload.userId}/uploads/`;
    const fileName = upload.name;
    const filePath = `${filePathPrefix}${fileName}`;
    const thumbFileEnding = `thumbs/${fileName.replace(/\.[^/.]+$/, `_${exports.THUMB_SIZE}x${exports.THUMB_SIZE}.webp`)}`;
    const thumbFilePath = `${filePathPrefix}${thumbFileEnding}`;
    return { filePath, thumbFilePath };
};
exports.getRunnitUploadFilePath = getRunnitUploadFilePath;
const getAvatarFilePath = (avatar) => {
    const filePathPrefix = avatar.teamId
        ? `avatars/teams/${avatar.teamId}/uploads/`
        : `avatars/users/${avatar.userId}/uploads/`;
    const fileName = avatar.name || 'avatar';
    const filePath = `${filePathPrefix}${fileName}`;
    const thumbFileEnding = `thumbs/${fileName.replace(/\.[^/.]+$/, `_${exports.AVATAR_SIZE}x${exports.AVATAR_SIZE}.webp`)}`;
    const thumbFilePath = `${filePathPrefix}${thumbFileEnding}`;
    return { filePath, thumbFilePath };
};
exports.getAvatarFilePath = getAvatarFilePath;
const getRunnitMaskFilePath = (mask) => {
    const filePathPrefix = mask.teamId
        ? `runnitMasks/teams/${mask.teamId}/masks/`
        : `runnitMasks/users/${mask.userId}/masks/`;
    const fileName = mask.name;
    const filePath = `${filePathPrefix}${fileName}`;
    return { filePath };
};
exports.getRunnitMaskFilePath = getRunnitMaskFilePath;
const getRunnitModelFilePath = (model) => {
    const destinationFolder = model.nodeRunId ? `runs/${model.nodeRunId}` : 'uploads';
    const filePathPrefix = model.teamId
        ? `runnitModels/teams/${model.teamId}/${destinationFolder}/`
        : `runnitModels/users/${model.userId}/${destinationFolder}/`;
    const fileName = model.file.name;
    const filePath = `${filePathPrefix}${fileName}`;
    return { filePath };
};
exports.getRunnitModelFilePath = getRunnitModelFilePath;
const getRunnitLayerDownloadFilePath = (nodeRunResult) => {
    // For template nodeRuns, use templateOriginalData.nodeRunId to find files in the original location
    // Otherwise, use the nodeRunResult.nodeRunId
    const nodeRunIdToUse = (0, lodash_1.get)(nodeRunResult, 'templateOriginalData.nodeRunId') || nodeRunResult.nodeRunId;
    const teamIdToUse = (0, lodash_1.get)(nodeRunResult, 'templateOriginalData.teamId') || nodeRunResult.teamId;
    const userIdToUse = (0, lodash_1.get)(nodeRunResult, 'templateOriginalData.userId') || nodeRunResult.userId;
    const filePathPrefix = teamIdToUse
        ? `runnitResults/teams/${teamIdToUse}/runs/${nodeRunIdToUse}/`
        : `runnitResults/users/${userIdToUse}/runs/${nodeRunIdToUse}/`;
    if (nodeRunResult.type === 'LAYERS' && nodeRunResult.downloadFile) {
        const fileName = nodeRunResult.downloadFile.name;
        const filePath = `${filePathPrefix}${fileName}`;
        return { filePath };
    }
    // Fallback to display file if download file is not available
    if (nodeRunResult.type === 'LAYERS' && nodeRunResult.displayFile) {
        const fileName = nodeRunResult.displayFile.name;
        const filePath = `${filePathPrefix}${fileName}`;
        return { filePath };
    }
    // Fallback to standard file for other types
    const fileName = (0, lodash_1.get)(nodeRunResult, 'file.name', '');
    const filePath = `${filePathPrefix}${fileName}`;
    return { filePath };
};
exports.getRunnitLayerDownloadFilePath = getRunnitLayerDownloadFilePath;
const buildFileNameForRunnitNodeRunResultDownload = (fileName, nodeRunResult, nodeRun) => {
    // For LAYERS type, use the download file name as-is without customization
    if (nodeRunResult.type === 'LAYERS' && nodeRunResult.downloadFile) {
        return nodeRunResult.downloadFile.name;
    }
    // Extract the prompt value to use for customizing the file name
    const promptFields = (0, runnitNodes_1.extractFieldsByFieldType)(((nodeRun && nodeRun.fields) || []), types_1.RUNNIT_NODE_FIELD_TYPE.PROMPT);
    const promptFieldInputVal = nodeRun && promptFields.length ? nodeRun.inputs[promptFields[0].fieldDefUuid] : null;
    const promptStrVal = (0, utils_1.extractPromptStringValue)(promptFieldInputVal);
    const extension = fileName.substring(fileName.lastIndexOf('.'));
    if (promptStrVal) {
        // Replace any model ID chips with 'MODEL'
        const MODEL_ID_CHIP_REGEX = /@{MODEL-(\S{12,36})}/g;
        const sanitizedName = promptStrVal
            .replace(MODEL_ID_CHIP_REGEX, 'MODEL')
            .slice(0, 100)
            .replace(/[^a-zA-Z0-9_-]+/g, '_')
            .replace(/^_+|_+$/g, ''); // Trim leading and trailing underscores
        return `${sanitizedName}-${nodeRunResult.uuid}${extension}`;
    }
    return `${nodeRunResult.uuid}${extension}`;
};
exports.buildFileNameForRunnitNodeRunResultDownload = buildFileNameForRunnitNodeRunResultDownload;
const buildFileNameForRunnitUploadDownload = (fileName, upload) => {
    const extension = fileName.substring(fileName.lastIndexOf('.'));
    return `${upload.id}${extension}`;
};
exports.buildFileNameForRunnitUploadDownload = buildFileNameForRunnitUploadDownload;
const buildFileNameForAvatarDownload = (fileName, avatar) => {
    const extension = fileName.substring(fileName.lastIndexOf('.'));
    return `${avatar.id}${extension}`;
};
exports.buildFileNameForAvatarDownload = buildFileNameForAvatarDownload;
const getRunnitNodeRunResultDownloadFilePath = (nodeRunResult) => {
    // For template nodeRuns, use templateOriginalData.nodeRunId to find files in the original location
    // Otherwise, use the nodeRunResult.nodeRunId
    const nodeRunIdToUse = (0, lodash_1.get)(nodeRunResult, 'templateOriginalData.nodeRunId') || nodeRunResult.nodeRunId;
    const teamIdToUse = (0, lodash_1.get)(nodeRunResult, 'templateOriginalData.teamId') || nodeRunResult.teamId;
    const userIdToUse = (0, lodash_1.get)(nodeRunResult, 'templateOriginalData.userId') || nodeRunResult.userId;
    const filePathPrefix = teamIdToUse
        ? `runnitResults/teams/${teamIdToUse}/runs/${nodeRunIdToUse}/`
        : `runnitResults/users/${userIdToUse}/runs/${nodeRunIdToUse}/`;
    if (nodeRunResult.type === 'ASSET_3D' && nodeRunResult.file) {
        // Coerce a missing/null name to '' — a provider may omit file_name — so the
        // path doesn't become a literal `.../null` (matches the sibling branches).
        const fileName = (0, lodash_1.get)(nodeRunResult, 'file.name') || '';
        const filePath = `${filePathPrefix}${fileName}`;
        return { filePath };
    }
    if (nodeRunResult.type === 'LAYERS' && nodeRunResult.downloadFile) {
        const fileName = nodeRunResult.downloadFile.name;
        const filePath = `${filePathPrefix}${fileName}`;
        return { filePath };
    }
    // Fallback to display file if download file is not available
    if (nodeRunResult.type === 'LAYERS' && nodeRunResult.displayFile) {
        const fileName = nodeRunResult.displayFile.name;
        const filePath = `${filePathPrefix}${fileName}`;
        return { filePath };
    }
    // Fallback to regular file for other types
    const fileName = (nodeRunResult.file && nodeRunResult.file.name) || '';
    const filePath = `${filePathPrefix}${fileName}`;
    return { filePath };
};
exports.getRunnitNodeRunResultDownloadFilePath = getRunnitNodeRunResultDownloadFilePath;
const getContentTypeFromExtension = (fileName) => {
    // TODO: This code is duplicated in the queueGpuJobs projects, get queueGpuJobs to pull in shared package, and import this function instead.
    const extension = (((fileName || '').split('.').pop() || '').split('?')[0] || '').toLowerCase(); // Extract file extension
    // Map of file extensions to MIME types
    const mimeTypes = {
        'mp4': 'video/mp4',
        'mkv': 'video/x-matroska',
        'mov': 'video/quicktime',
        'ogg': 'video/ogg', // Can also be 'audio/ogg' depending on context
        'webm': 'video/webm',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'pdf': 'application/pdf',
        'html': 'text/html',
        'css': 'text/css',
        'js': 'application/javascript',
        'json': 'application/json',
        'txt': 'text/plain',
        'xml': 'application/xml',
        'mp3': 'audio/mpeg',
        'wav': 'audio/wav',
        'zip': 'application/zip',
        'avi': 'video/x-msvideo',
        'svg': 'image/svg+xml',
        // Add more extensions and MIME types as needed
    };
    // Return the corresponding MIME type, or default to 'application/octet-stream'
    return mimeTypes[extension] || 'application/octet-stream';
};
exports.getContentTypeFromExtension = getContentTypeFromExtension;
